<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="Master Area">
      <!-- <b-card-text>Area.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Province -->
            <b-col cols="12">
              <b-form-group label="Province" label-for="v-Province">
                <validation-provider #default="{ errors }"  name="Province">
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="province"
                    :reduce="(province) => province.value"
                    id="v-Province"
                    v-model="form.province"
                    label="title"
                    placeholder="--Select Province --"
                    class="w-100"
                    @input="onProvinceChange"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Regency -->
            <b-col cols="12">
              <b-form-group label="Regency" label-for="v-Regency">
                <validation-provider #default="{ errors }"  name="Regency">
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="regency"
                    :reduce="(regency) => regency.value"
                    v-model="form.regency"
                    label="title"
                    id="v-Regency"
                    placeholder="--Select Regency --"
                    class="w-100"
                    @input="onRegencyChange"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
             <!-- District -->
            <b-col cols="12">
              <b-form-group label="District" label-for="v-District">
                <validation-provider #default="{ errors }"  name="District">
                  <v-select
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="district"
                    :reduce="(district) => district.value"
                    v-model="form.district"
                    label="title"
                    id="v-District"
                    placeholder="--Select District --"
                    class="w-100"
                    @input="onFilterDistrictChange"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Site -->
            <b-col cols="12">
              <b-form-group label="Site" label-for="v-Site">
                <validation-provider #default="{ errors }"  name="Site">
                  <v-select 
                    id="v-Site" 
                    v-model="form.select_1" 
                    placeholder="Chose Site" 
                    autocomplete="off" 
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
                    label="title" 
                    :options="sites" 
                    :reduce="sites => sites.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Name -->
            <b-col cols="12">
              <b-form-group label="Name" label-for="v-Name">
                <validation-provider #default="{ errors }"  name="Name" rules="required">
                  <b-form-input  id="v-Name" :state="errors.length > 0 ? false:null" v-model="form.text_1" placeholder="Name" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Description -->
            <b-col cols="12">
              <b-form-group label="Description" label-for="v-Description">
                <validation-provider #default="{ errors }"  name="Description" rules="required">
                  <b-form-input  id="v-Description" :state="errors.length > 0 ? false:null" v-model="form.text_2" placeholder="Description" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BCol, BFormGroup, BFormCheckbox,  BFormInput, BForm, BButton, BCard,  BImg} from 'bootstrap-vue'
import { mapState } from 'vuex'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { vSelect, BOverlay, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BFormCheckbox,  ValidationProvider, ValidationObserver, BCard, BImg, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      form: {
        id: null, 
        province: null, 
        regency: null, 
        district: null, 
        select_1: null, 
        text_1: '',
        text_2: '', 
        text_3: '', 
        imageUrl: require('@/assets/images/icons/jpg.png'), 
        setImage: 'none',
        logo: null},
      show: false,
      required 
    }
  },
  computed: {
    ...mapState({ 
      siteOptions: state => state.site.options,
      province: state => state.region.province,
      regency: state => state.region.regency,
      district: state => state.region.district,
      sites: state => state.site.options,
    })
  },
  created () {
    this.$store.dispatch('region/province')
  },
  methods: {
    onProvinceChange(selectedProvince) {
      this.$store.dispatch('region/regency', selectedProvince);
      this.$store.dispatch('site/setFilterProvince', selectedProvince);
    },    
    onRegencyChange(selectedRegency) {
      this.$store.dispatch('region/district', selectedRegency);
    },
    onFilterDistrictChange() {
      this.$store.dispatch('site/getByFilterOnly', {
        province: this.updateFilter.province, 
        regency: this.updateFilter.regency,
        district: this.updateFilter.district
      });
    },
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('area/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('area/getById', id).then(data => {
        this.form.id = data.id
        this.form.text_1 = data.name
        this.form.text_2 = data.description
        this.form.id = data.id
        this.form.province = data.province_id
        this.form.regency = data.regency_id
        this.form.district = data.district_id
        this.form.select_1 = data.site_id
        this.show = false
        this.onProvinceChange(data.province_id)
        this.onRegencyChange(data.regency_id)
        this.onFilterDistrictChange()
      })
    }
  },
  mounted () {
    this.$store.dispatch('site/getAll')
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>